import ajax from './ajax';
var url = '//gateway.i-mineral.cn/lostfound-web/user/CreateQRCode/code';
// var url = '//172.17.0.108:8083/user/CreateQRCode/code';

export const savedo = async (params: any) => {
  return ajax(`${url}/save`, params, 'POST');
};
export const deleteCourse = async (typeId: any) => {
  return ajax(`${url}/deleteCourse?typeId=${typeId}`);
};

export const getCourse = async (typeId: any) => {
  return ajax(`${url}/getCourse?typeId=${typeId}`);
};
